function dropdown() {
    const menuItems = document.querySelectorAll('.dropdown-toggler');

    const dropdownTimeline = gsap.timeline({paused: true});

    dropdownTimeline
        .to('html', {
            overflow: 'hidden',
            duration: .1
        })
        .to('.top-navigation__dropdown', {
            autoAlpha: 1,
            duration: .1,
            ease: "power4.out"
        })
        .to('.top-navigation', {
            className: '+=position-fixed w-100 top left pt-4 pt-lg-5 px-3 z-5 top-navigation top-navigation--dropdown-open',
            duration: 0
        })
        .to('.top-navigation__dropdown__container__background', {
            scaleY: 1,
            duration: 1
        }).to('.top-navigation__dropdown__separator', {
        scaleY: 1,
        duration: .8,
    }, '-=.8')
        .to('.top-navigation__close', {
            opacity: 1,
            y: 0,
            duration: .9,
        }, '-=.1').staggerTo('.top-navigation__dropdown__column', .7, {
        y: 0,
        autoAlpha: 1
    }, .03, '-=1.5');

    function toggle(event) {
        event.preventDefault();

        const menu = document.querySelector('.top-navigation__dropdown');

        if (!menu.classList.contains('top-navigation__dropdown--open')) {
            menu.classList.add('top-navigation__dropdown--open');

            dropdownTimeline.play();

        } else {
            setTimeout(function () {
                menu.classList.remove('top-navigation__dropdown--open')
            }, 500);

            dropdownTimeline.reverse(.5);
        }
    }

    for (const item of menuItems) {
        item.addEventListener('click', toggle);
    }
}

function mobileAccordeon() {
    document.addEventListener("DOMContentLoaded", function () {
        if (window.innerWidth < 768) {
            const accordeons = document.querySelectorAll('.accordeon');

            function accordeonToggle(element) {
                element.addEventListener('click', function () {
                    const container = element.querySelector('.accordeon__container');
                    const list = element.querySelector('.accordeon__container ul');

                    const listHeight = list.clientHeight;

                    console.log(listHeight);

                    if (!element.classList.contains('open')) {
                        gsap.to(container, .7, {
                            onStart: function() {
                                element.classList.add('open');
                            },
                            height: listHeight
                        })
                    } else {
                        gsap.to(container, 1, {
                            height: 0,
                            onComplete: function() {
                                element.classList.remove('open')
                            }
                        });
                    }
                });
            }

            for (const accordeon of accordeons) {
                accordeonToggle(accordeon);
            }
        }
    });
}

export {dropdown, mobileAccordeon};
